import React, { useState, useEffect } from "react";
import { FaPaperPlane } from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import "./FellowshipForm.scss";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const FellowshipForm = ({ onSubmit }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    education: '',
    experience: '',
    interests: '',
    additional: '',
    source: ''
  });

  const [errors, setErrors] = useState({
    name: '',
    email: '',
    education: '',
    interests: ''
  });

  const [successMessage, setSuccessMessage] = useState('');

  // Initialize EmailJS - using PUBLIC_KEY
  useEffect(() => {
    emailjs.init("n-n62XZBnXR0TXlQj");
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    
    // Clear error when user types
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ""
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }
    
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }
    
    if (!formData.education.trim()) {
      newErrors.education = "Education background is required";
    }
    
    if (!formData.interests.trim()) {
      newErrors.interests = "Research interests are required";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setIsLoading(true);
    
    try {
      // Send email using EmailJS with properly formatted template parameters
      // Save to MongoDB + send email via backend
      const response = await fetch(`${API_URL}/send-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          education: formData.education,
          experience: formData.experience,
          interests: formData.interests,
          source: formData.source,
          additional: formData.additional,
        }),
      });

      if (response.ok) {
        // Reset form
        setFormData({
          name: "",
          email: "",
          phone: "",
          education: "",
          experience: "",
          interests: "",
          additional: "",
          source: ""
        });
        
        setSuccessMessage("Your application has been submitted successfully! We'll contact you soon.");
        
        // If onSubmit prop exists, call it with the form data
        if (onSubmit) {
          onSubmit(formData);
        }
        
        setTimeout(() => {
          setSuccessMessage("");
        }, 5000);
      } else {
        throw new Error('Failed to send email');
      }
      
    } catch (error) {
      console.error('Email sending failed:', error);
      setErrors({
        ...errors,
        form: "Failed to submit application. Please try again."
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fellowship-form">
      <h3>Apply for Fellowship</h3>
      <p>Join our community of researchers and innovators. Fill out the form below to apply for the Cograd Fellowship Program.</p>
      
      {successMessage && (
        <div className="success-message">
          {successMessage}
        </div>
      )}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            name="name"
            placeholder="Your Name *"
            value={formData.name}
            onChange={handleInputChange}
            disabled={isLoading}
            required
          />
          {errors.name && <div className="error-message">{errors.name}</div>}
        </div>
        
        <div className="form-group">
          <input
            type="email"
            name="email"
            placeholder="Your Email *"
            value={formData.email}
            onChange={handleInputChange}
            disabled={isLoading}
            required
          />
          {errors.email && <div className="error-message">{errors.email}</div>}
        </div>
        
        <div className="form-group">
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleInputChange}
            disabled={isLoading}
          />
        </div>
        
        <div className="form-group">
          <textarea
            name="education"
            placeholder="Education Background *"
            value={formData.education}
            onChange={handleInputChange}
            disabled={isLoading}
            required
          ></textarea>
          {errors.education && <div className="error-message">{errors.education}</div>}
        </div>
        
        <div className="form-group">
          <textarea
            name="experience"
            placeholder="Professional Experience"
            value={formData.experience}
            onChange={handleInputChange}
            disabled={isLoading}
          ></textarea>
        </div>
        
        <div className="form-group">
          <textarea
            name="interests"
            placeholder="Research Interests *"
            value={formData.interests}
            onChange={handleInputChange}
            disabled={isLoading}
            required
          ></textarea>
          {errors.interests && <div className="error-message">{errors.interests}</div>}
        </div>
        
        <div className="form-group">
          <input
            type="text"
            name="source"
            placeholder="How did you find us?"
            value={formData.source}
            onChange={handleInputChange}
            disabled={isLoading}
          />
        </div>
        
        <div className="form-group">
          <textarea
            name="additional"
            placeholder="Additional Information"
            value={formData.additional}
            onChange={handleInputChange}
            disabled={isLoading}
          ></textarea>
        </div>
        
        <button type="submit" className="submit-button" disabled={isLoading}>
          {isLoading ? "Sending..." : "Submit Application"}
          <FaPaperPlane />
        </button>
      </form>
    </div>
  );
};

export default FellowshipForm; 